import { render, staticRenderFns } from "./SoilOverviewStatistics.vue?vue&type=template&id=3ed9c7f6&scoped=true&"
import script from "./SoilOverviewStatistics.vue?vue&type=script&lang=js&"
export * from "./SoilOverviewStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SoilOverviewStatistics.vue?vue&type=style&index=0&id=3ed9c7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed9c7f6",
  null
  
)

export default component.exports